// @ts-check

import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import _module from '@/store/base/module'

const module = {
  state: {
    currentRequest: null
  },

  getters: {

  },

  mutations: {

  },
  actions: {
    submitForm ({ commit }, input) {
      return ApiUtils.postData({
        data: [
          { api: 'ZZ0101LecturerApplicationService.submitForm', input }
        ]
      }).then((data) => {
        return data[0].output
      })
    },
    getLists ({ commit }, input) {
      return ApiUtils.postData({
        data: [
          { api: 'ZZ0101LecturerApplicationService.getLists', input }
        ]
      }).then((data) => {
        return data[0].output
      })
    },
    updateStatus ({ commit }, input) {
      return ApiUtils.postData({
        data: [
          { api: 'ZZ0101LecturerApplicationService.updateStatus', input }
        ]
      }).then((data) => {
        return data[0].output
      })
    },
    async ZZ0201_getCurrentRequest ({ commit }, payload) {
      const res = await ApiUtils.postData({
        data: {
          ZZ0201_getCurrentRequest: { api: 'ZZ0101LecturerApplicationService.ZZ0201_getCurrentRequest', input: payload }
        }
      })
      if (res.ZZ0201_getCurrentRequest.output === null) return
      commit('setState', {
        currentRequest: res.ZZ0201_getCurrentRequest.output
      })
    }
  }
}

export default ObjArrUtils.merge(_module, module)
